interface EmptyStateProps {
  title: string;
  description: string;
}

export const EmptyState = ({ title, description }: EmptyStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center h-full text-txtBody">
      <h3 className="text-xl font-semibold">{title}</h3>
      <span className="text-center">{description}</span>
    </div>
  );
};
